module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAUCAYAAACAl21KAAAAsklEQVQ4T+2U0REBQRBE30SATIjAyYAMiMBlgAgIQQhkQASEciIY1VV7an6oG75U3f5t1c7bnt6dNncfAntgSfd1B3ZmdmpLzN0vwLQ743WyMbNRBPkXkLZkBkhdJUW/gipg04PePofM7j36/Fv/xKNrcuaakhh1HJFFjIQM0N23ESTTdMMtAwEmwDyCVoBCapwEKUKkaK3pF0DBdiyqMiylq5L1LJA2hyJxkKEAj9JJ/QRK83HQD8xZVQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/ksbd.png
// module id = QiQC
// module chunks = 2